import React, { useState } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Typography,
  Grid,
  Chip,
  Checkbox,
  FormGroup,
  FormControlLabel,
} from "@mui/material";

const categories = [
  "Shirt",
  "T-Shirt",
  "Sneakers",
  "Joggers",
  "Vests",
  "Knitwear",
  "Shorts",
];

const AddNewProduct = () => {
  const [product, setProduct] = useState({
    title: "",
    sou: { color: "", size: "" },
    brand: "",
    description: "",
    price: "",
    status: "Published",
    tags: [],
    category: [],
    images: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct((prev) => ({ ...prev, [name]: value }));
  };

  const handleTagsChange = (e) => {
    if (e.key === "Enter" && e.target.value) {
      setProduct((prev) => ({
        ...prev,
        tags: [...prev.tags, e.target.value],
      }));
      e.target.value = "";
    }
  };

  const handleTagDelete = (tagToDelete) => {
    setProduct((prev) => ({
      ...prev,
      tags: prev.tags.filter((tag) => tag !== tagToDelete),
    }));
  };

  const handleCategoryChange = (category) => {
    setProduct((prev) => ({
      ...prev,
      category: prev.category.includes(category)
        ? prev.category.filter((c) => c !== category)
        : [...prev.category, category],
    }));
  };

  const handleImageUpload = (e) => {
    setProduct((prev) => ({
      ...prev,
      images: e.target.files,
    }));
  };

  return (
    <Box sx={{ p: 4, background: "#f8f9fa", minHeight: "100vh" }}>
         <Box sx={{ display: "flex", justifyContent: "end", mt: 3, gap: 2 }}>
        <Button variant="outlined">Save to Draft</Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#3bb77e",
            "&:hover": { backgroundColor: "#32a96f" },
          }}
        >
          Publish
        </Button>
      </Box>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
        Add New Product
      </Typography>

      <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
        {/* Left Section */}
        <Box
          sx={{
            flex: 2,
            background: "#fff",
            p: 3,
            borderRadius: 2,
            boxShadow: 1,
          }}
        >
          <TextField
            label="Product Title"
            name="title"
            value={product.title}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            SKU (Stock Keeping Unit)
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                label="Color"
                name="color"
                value={product.sou.color}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
            <Grid item xs={4}>
              <TextField
                label="Size"
                name="size"
                value={product.sou.size}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          </Grid>

          <TextField
            label="Brand"
            name="brand"
            value={product.brand}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Description
          </Typography>
          <TextField
            label="Description"
            name="description"
            value={product.description}
            onChange={handleChange}
            fullWidth
            multiline
            rows={4}
            margin="normal"
          />

          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Upload Images
          </Typography>
          <input type="file" multiple onChange={handleImageUpload} />
        </Box>

        {/* Right Section */}
        
        <Box
          sx={{
            flex: 1,
            background: "#fff",
            p: 3,
            borderRadius: 2,
            boxShadow: 1,
          }}
        >
          <TextField
            label="Price"
            name="price"
            value={product.price}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />

          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              name="status"
              value={product.status}
              onChange={handleChange}
            >
              <MenuItem value="Published">Published</MenuItem>
              <MenuItem value="Draft">Draft</MenuItem>
            </Select>
          </FormControl>

          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Tags
          </Typography>
          <TextField
            placeholder="Type and press enter"
            onKeyPress={handleTagsChange}
            fullWidth
            margin="normal"
          />
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
            {product.tags.map((tag, index) => (
              <Chip
                key={index}
                label={tag}
                onDelete={() => handleTagDelete(tag)}
              />
            ))}
          </Box>

          <Typography variant="subtitle1" sx={{ mt: 2 }}>
            Categories
          </Typography>
          <FormGroup>
            {categories.map((cat) => (
              <FormControlLabel
                key={cat}
                control={
                  <Checkbox
                    checked={product.category.includes(cat)}
                    onChange={() => handleCategoryChange(cat)}
                  />
                }
                label={cat}
              />
            ))}
          </FormGroup>
        </Box>
      </Box>
    </Box>
  );
};

export default AddNewProduct;
